export const ANALYTICS_DASHBOARD_PATH = '/analytics';
export const DOWNLOAD_KPI_DATA_URL = `${process.env.BACKEND_URL}download_data`;
export const DOWNLOAD_SMART_INBOX_ANALYTICS_DATA = `${process.env.BACKEND_URL}download_smart_inbox_analytics`;
